import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { CloseButton, Fade } from '../components/common/Toast';

import DashboardLayout from './DashboardLayout';
import AdminContainer from '../tpw/layouts/AdminContainer';
//const Landing = loadable(() => import('../components/landing/Landing'));
import ErrorLayout from './ErrorLayout';

import { debugMode } from '../config.js';

import loadable from '@loadable/component';

const Landing = loadable(() => import('../tpw/layouts/Landing'));

const AuthBasicLayout = loadable(() => import('./AuthBasicLayout'));
const WizardLayout = loadable(() => import('../components/auth/wizard/WizardLayout'));
const AuthCardRoutes = loadable(() => import('../components/auth/card/AuthCardRoutes'));
const AuthSplitRoutes = loadable(() => import('../components/auth/split/AuthSplitRoutes'));

const Layout = () => {
  useEffect(() => {
    AuthBasicLayout.preload();
    Landing.preload();
    WizardLayout.preload();
    AuthCardRoutes.preload();
    AuthSplitRoutes.preload();
  }, []);

  return (
    <Router fallback={<span />}>
      <Switch>
        {debugMode && (<Route path="/template/authentication/card" component={AuthCardRoutes} />)}
        {debugMode && (<Route path="/template/authentication/split" component={AuthSplitRoutes} />)}
        {debugMode && (<Route path="/template/authentication/wizard" component={WizardLayout} />)}
        {debugMode && (<Route path="/template/authentication/basic" component={AuthBasicLayout} />)}
        {debugMode && (<Route path="/template" component={DashboardLayout} />)}
        <Route path="/admin" component={AdminContainer} />
        <Route path="/errors" component={ErrorLayout} />
        <Route path="/" exact component={Landing} />
        <Redirect to="/errors/404" />
      </Switch>
      <ToastContainer transition={Fade} closeButton={<CloseButton />} position={toast.POSITION.BOTTOM_LEFT} />
    </Router>
  );
};

export default Layout;
